import { useState, useEffect } from 'react';
import useApi from "./useApi";


const useOrderDetails = (orderId) => {
    const {get} = useApi(); // <-- is useApi a hook?
    const {data, isLoading, error} = get(`/admin/orders/${orderId}`);

    return {
        order: data?.data || null,
        isLoading,
        error,
    };
}

export default useOrderDetails;
